var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-input element-complete"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"title",class:{ on: true }},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.data.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }